import '../styles/globals.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.min.css';
// import "nprogress/nprogress.css";
import 'react-phone-input-2/lib/bootstrap.css';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

import type { AppProps } from 'next/app';
import { useEffect } from 'react';
import { AuthProvider } from '../contexts/Auth/AuthProvider';
import { useRouter } from 'next/router';
// import Nprogress from 'nprogress';
import Head from 'next/head';

import { Alerta } from '../components/Alerta';
import Analytics from '../components/Analytics';
import { setStorageItem } from '../utils/localStorage';
import { TiktokPixel } from '../components/TiktokPixel';
import { PixelFacebook } from '../components/pixel/facebook/Pixel';
import { Clarity } from '../components/Clarity';
import { GTM } from '../components/GTM';
import { setDefaultLocale } from 'react-datepicker';
import moment from 'moment-timezone';

import 'moment/locale/pt-br'; // Importa a localização em português do Brasil

moment.tz.setDefault('America/Sao_Paulo');

function MyApp({ Component, pageProps }: AppProps) {
  const router = useRouter();

  useEffect(() => {
    if (typeof document !== 'undefined') {
      require('bootstrap/dist/js/bootstrap.min');
    }
  }, []);

  useEffect(() => {
    const utmSource = router.query.utm_source;
    if (utmSource) {
      setStorageItem('UTM_SOURCE', utmSource);
    }
  }, [router.query]);

  return (
    <AuthProvider>
      <>
        <Head>
          <title>Rifaweb</title>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Head>
        
        <Alerta />
        <Analytics />
        <Clarity />
        {router.pathname !== '/obrigado/pago' && <GTM />}
        {/* <TiktokPixel /> */}

        <Component {...pageProps} />
      </>
    </AuthProvider>
  );
}

export default MyApp;
